/**
 * Fiche produit échantillon — carrousel 21 teintes + nuancier (22).
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-bio-sample-product]');
  const configEl = document.getElementById('BioSampleProductConfig');
  if (!root || !configEl) return;

  const config = JSON.parse(configEl.textContent);
  const track = root.querySelector('[data-bio-carousel-track]');
  const assetBase = (config.assetBase || '').replace(/\/?$/, '/');

  let teintes = [];
  let nuancierMeta = null;
  let slides = [];
  let currentSlug = config.currentSlug;

  function assetUrl(path) {
    if (!path) return '';
    let url = assetBase + path.replace(/^\//, '');
    if (/nuancier-carousel-(vignette|lifestyle)\.jpe?g$/i.test(path)) {
      url += (url.includes('?') ? '&' : '?') + 'v=3';
    }
    return url;
  }

  function slideUrl(item) {
    if (item.isNuancier) {
      return `${config.routes.root}products/${item.productHandle || config.nuancierHandle || 'nuancier-complet-biocemento'}`;
    }
    return `${config.routes.root}products/${item.productHandle}`;
  }

  function buildSlides() {
    slides = teintes.map((t) => ({ ...t, isNuancier: false }));
    if (nuancierMeta) {
      slides.push({
        ...nuancierMeta,
        isNuancier: true,
        name: nuancierMeta.shortName || nuancierMeta.name,
      });
    }
  }

  function isActive(item) {
    if (item.isNuancier) {
      return (
        currentSlug === item.slug ||
        config.productUrl?.includes(item.productHandle) ||
        config.productUrl?.includes(config.nuancierHandle)
      );
    }
    return item.slug === currentSlug;
  }

  function renderTrack() {
    if (!track) return;
    track.innerHTML = slides
      .map((item) => {
        const active = isActive(item) ? ' is-active' : '';
        const nuancierClass = item.isNuancier ? ' bio-sample-carousel__item--nuancier' : '';
        const visual = item.isNuancier
          ? `<span class="bio-sample-carousel__thumb"><img src="${assetUrl(item.carouselImage || item.image)}" alt="" width="112" height="140" loading="lazy" decoding="async"></span>`
          : `<span class="bio-sample-carousel__swatch" aria-hidden="true"></span>`;
        return `
          <a class="bio-sample-carousel__item${nuancierClass}${active}" href="${slideUrl(item)}" role="listitem"
            data-bio-carousel-item data-slug="${item.slug}"${item.isNuancier ? ' data-is-nuancier' : ''}
            aria-label="${item.isNuancier ? 'Nuancier complet' : `Teinte ${item.num}, ${item.name}`}"
            style="--tone:${item.hex || '#9a8f82'}">
            ${visual}
            <span class="bio-sample-carousel__num">${item.num}</span>
            <span class="bio-sample-carousel__name">${item.name}</span>
          </a>`;
      })
      .join('');

    track.querySelector('.bio-sample-carousel__item.is-active')?.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  }

  function updateHero() {
    const item = slides.find((x) => isActive(x));
    if (!item || item.isNuancier) return;

    const img = root.querySelector('[data-bio-sample-projection]');
    const swatch = root.querySelector('[data-bio-sample-swatch]');
    const tagline = root.querySelector('[data-bio-sample-tagline]');
    const copy = root.querySelector('[data-bio-sample-copy]');

    if (img) {
      img.src = assetUrl(item.projection);
      img.alt = `${item.name} en situation`;
    }
    if (swatch) swatch.style.background = item.hex;
    if (tagline) tagline.textContent = item.tagline || '';
    if (copy) copy.textContent = item.copy || '';

    try {
      localStorage.setItem('biocemento:teinte', item.slug);
    } catch (e) { /* ignore */ }
  }

  function navigate(delta) {
    const idx = slides.findIndex((t) => isActive(t));
    if (idx < 0) return;
    const next = slides[(idx + delta + slides.length) % slides.length];
    window.location.href = slideUrl(next);
  }

  async function loadNuancier() {
    if (!config.nuancierDataUrl) return;
    try {
      const res = await fetch(config.nuancierDataUrl);
      nuancierMeta = await res.json();
    } catch (e) {
      nuancierMeta = null;
    }
  }

  async function init() {
    const res = await fetch(config.teintesUrl);
    teintes = await res.json();
    teintes.sort((a, b) => parseInt(a.num, 10) - parseInt(b.num, 10));

    await loadNuancier();
    buildSlides();

    const fromHandle = teintes.find((t) => t.productHandle && config.productUrl?.includes(t.productHandle));
    if (fromHandle) currentSlug = fromHandle.slug;
    if (nuancierMeta && config.productUrl?.includes(nuancierMeta.productHandle)) {
      currentSlug = nuancierMeta.slug;
    }

    renderTrack();
    updateHero();

    const trackEl = root.querySelector('[data-bio-carousel-track]');
    const carouselStep = () => {
      const item = trackEl?.querySelector('[data-bio-carousel-item]');
      if (!item) return 82;
      const gap = trackEl ? parseFloat(getComputedStyle(trackEl).gap) || 10 : 10;
      return item.offsetWidth + gap;
    };

    const scrollCarousel = (delta) => {
      if (!trackEl) return;
      trackEl.scrollBy({ left: delta * carouselStep(), behavior: 'smooth' });
    };

    root.querySelector('[data-bio-carousel-prev]')?.addEventListener('click', (e) => {
      if (e.shiftKey) {
        navigate(-1);
        return;
      }
      scrollCarousel(-1);
    });
    root.querySelector('[data-bio-carousel-next]')?.addEventListener('click', (e) => {
      if (e.shiftKey) {
        navigate(1);
        return;
      }
      scrollCarousel(1);
    });

    if (trackEl) {
      trackEl.setAttribute('tabindex', '0');
      trackEl.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          scrollCarousel(-1);
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          scrollCarousel(1);
        }
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.target.closest('input, textarea, select, [data-bio-carousel-track]')) return;
      if (e.key === 'ArrowLeft') navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });
  }

  init().catch(console.error);
})();
